import React from 'react'
import { useEffect } from 'react';
import { useState } from 'react';

import '../../ProductFeature.css'
import { IoMdCheckmark } from 'react-icons/io';

const FeatureCheckbox = ({ feature, handleClick, value, isChecked }) => {
  const [checked, setChecked] = useState(false);


  useEffect(() => {
    setChecked(isChecked(feature.name, feature.value))
  }, [feature])

  const OnChange = () => {
    setChecked(!checked);

  }

  const toggleCheckbox = () => {
    setChecked(!isChecked);
  };

  return (
    <div className='feature-value row align-items-center' onClick={() => { handleClick(feature.name, feature.value) }}>
      <div
        className={`col-1 checkbox ${checked ? "checked" : "unchecked"}`}
        onClick={toggleCheckbox}
      >
        {checked && <span className="checkmark"><IoMdCheckmark /></span>}
      </div>
      {/* <div className='col-1'><input className='feature-value-checkbox ' type="checkbox" value={value} onChange={(e) => OnChange(e)} checked={checked} /></div> */}
      <div className='col'>{feature.value}</div>
    </div>
  )
}

export default FeatureCheckbox